/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import { alias } from '@ember/object/computed';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { filterBy } from '@linc-technologies/linced-common/utils/arrays';

export default class EnrolResult extends Component {
  @service
  session;

  // enrolURI provides the website to send users to when showing a default
  // 'go to ENROL' link.
  enrolURI = 'https://enrol.education.govt.nz';

  response = null;

  @alias('response.nzMoe.type')
  type;

  @alias('response.nzMoe.learners.firstObject')
  result;

  @alias('response.generalErrors')
  generalErrors;

  @alias('response.structuralErrors')
  structuralErrors;

  @alias('response.validationErrors')
  validationErrors;

  @alias('response.businessRuleErrors')
  businessRuleErrors;

  @alias('response.otherDexErrors')
  otherDexErrors;

  @alias('response.differences')
  differences;

  // updateDetails should be passed in to this component.
  updateDetails() {}

  @action
  handleUpdateDetails() {
    this.updateDetails(filterBy(this.differences, 'different'));
  }
}
